import { render } from "./LocalReportStep1.vue?vue&type=template&id=9f73470e&scoped=true&ts=true"
import script from "./LocalReportStep1.vue?vue&type=script&lang=ts"
export * from "./LocalReportStep1.vue?vue&type=script&lang=ts"

import "./LocalReportStep1.vue?vue&type=style&index=0&id=9f73470e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9f73470e"]])

export default __exports__